import React from 'react'

const Phoneauthnav = () => {
    return (
        <div className="bg-gray-100 flex px-5 mx-auto items-center flex-1">
                <h1 className="font-bold flex-1 flex justify-center text-xl sm:text-2xl">Phone number</h1>
                <h1 className="opacity-40 font-bold text-xl sm:text-2xl">Done</h1>
        </div>
    )
}

export default Phoneauthnav
